module.exports = __webpack_public_path__ + "img/logo.42fbd67e.png";